import { Injectable } from "@angular/core";
import {
  Router,
} from "@angular/router";
import { HTTPService } from "./http.service";
import { UserAuthenticationServices } from "./user-authentication.services";

@Injectable({
  providedIn: HTTPService,
  useValue: false,
})
export class IntegrationServices {
  constructor(
    private http: HTTPService,
    public router: Router,
    private user:UserAuthenticationServices
  ) {}

  

  mktpTipInt = [];
  tipIntArr = [];
  resultsCfi = [];
  lastIntegration = {};

  async loadIntegrations(idConf) {
    await new Promise((resolve, reject) => {
      let sqlFindSequenceCfg = ` SELECT IDCONF, SERVICETYPE, SEQUENCE ,NAME, ACTIVE FROM MKTPCFI WHERE IDCONF = '${idConf}' `;

      let queryFindSequence = {
        entityName: "MKTPCFI",
        sql: sqlFindSequenceCfg,
      };

      this.http
        .post(
          queryFindSequence,
          "JsonBrokerServices/findnative",
          false,
          true,
          true
        )
        .subscribe((con) => {
          let mktpCfiResult = con["SQL"];
          this.resultsCfi = [];
          let index = 0;

          mktpCfiResult.forEach((m) => {
            let cfi = {
              idConf: m["IDCONF"],
              serviceType: m["SERVICETYPE"],
              sequence: m["SEQUENCE"],
              index: index,
              nameIntegration: m['NAME'],
              active: m['ACTIVE']
            };

            this.resultsCfi.push(cfi);
            index++;
          });

          resolve(this.resultsCfi);
        });
    });
  }

  async removeIntegration(idConf, sequence) {
    await new Promise((resolve, reject) => {
      let remove: Object = {};

      remove["entityName"] = "Mktpcfi";
      remove["condition"] = "IDCONF = " + idConf + " AND SEQUENCE =" + sequence;

      this.http.post(remove, "JsonBrokerServices/remove", false).subscribe(
        (data) => {
          resolve(data);
        },
        (error) => {
          reject(error)
          throw error;
        },
        () => {}
      );
    });
  }

  async saveIntegration(idConf, serviceType) {
    await new Promise((resolve, reject) => {
      let sqlFindSequenceCfg = ` SELECT MAX(SEQUENCE)+1 AS SEQUENCE FROM MKTPCFI WHERE IDCONF = '${idConf}' `;

      let queryFindSequence = {
        entityName: "MKTPCFI",
        sql: sqlFindSequenceCfg,
      };

      this.http
        .post(
          queryFindSequence,
          "JsonBrokerServices/findnative",
          false,
          true,
          true
        )
        .subscribe((con) => {
          let mktpCfiResult = con["SQL"];

          let sequence = 1;

          if (mktpCfiResult != null && mktpCfiResult.length > 0) {
            if (mktpCfiResult[0]["SEQUENCE"]) {
              sequence = mktpCfiResult[0]["SEQUENCE"];
            }
          }

          let jsonSave: Object = {
            entityName: "Mktpcfi",
            IDCONF: idConf,
            SERVICETYPE: serviceType,
            SEQUENCE: sequence,
            EXECORDER: sequence,
            ACTIVE:'N',
            EXECUTION:1,
            RECMODIFYBY: this.user.user.iduser
          };

          this.lastIntegration = jsonSave;

          this.http.post(jsonSave, "JsonBrokerServices/save", false).subscribe(
            (me) => {
              resolve(this.lastIntegration);
            },
            (error) => {
              throw error;
            }
          );
        });
    });
  }

  async getTypeIntegrations(query) {
    await new Promise((resolve, reject) => {
      let sqlFindIntegrations = ` SELECT C.ID, C.NOMEINT, C.NUINT, C.ICONINT FROM MKTPTIPINT C`;
      sqlFindIntegrations += ` WHERE C.ACTIVE ='S'`;
      if (query != null) {
        if (isNaN(query)) {
          //nome
          sqlFindIntegrations += ` AND C.NOMEINT LIKE '%${query}%' `;
        } else {
          //codigo
          sqlFindIntegrations += ` AND C.NUINT = '${query}' `;
        }

        
      }

      let queryFindInt = {
        entityName: "MKTPTIPINT",
        sql: sqlFindIntegrations,
      };

      this.http
        .post(queryFindInt, "JsonBrokerServices/findnative", false, true, true)
        .subscribe((con) => {
          this.mktpTipInt = con["SQL"];
          this.tipIntArr = [];

          this.mktpTipInt.forEach((m) => {
            let integration = {
              name: m["NUINT"] + " - " + m["NOMEINT"],
              id: m["ID"],
              nuInt: m["NUINT"],
              iconInt: this.isSvg(m["ICONINT"]) ? this.prepareSVG(m["ICONINT"]) :m["ICONINT"],
              svg:m["ICONINT"]==null? false : this.isSvg(m["ICONINT"])
            };

            this.tipIntArr.push(integration);
          });

          resolve(this.tipIntArr);
        });
    });
  }
  prepareSVG(ico: string) {
    if ( ico!= null ){
      let icoR = null;
      icoR = ico.substring(ico.toUpperCase().indexOf('SVG_')+4).toLowerCase();
      return icoR;
    }else{
      return null;
    }
    
  }

  isSvg(ico: string) {
    if ( ico.toUpperCase().startsWith('SVG_')){
      return true;
    }else{
      return false;
    }
  }
}
